import { Injectable } from '@angular/core';

@Injectable()
export class GlobalsService {
  private lastAuthTime;
  private loginTracked;
  private registrationTracked;
  
  constructor() {}

  setLastAuthTime(val) {
    this.lastAuthTime = val;
  }

  getLastAuthTime() {
    return this.lastAuthTime ;
  }

  setLoginTracked(val) {
    this.loginTracked = val;
  }

  getLoginTracked() {
    return this.loginTracked ;
  }

  setRegistrationTracked(val) {
    this.registrationTracked = val;
  }

  getRegistrationTracked() {
    return this.registrationTracked ;
  }
}


// WEBPACK FOOTER //
// ./src/app/service/global.service.ts